import { siteData } from "../data/mock";
import { MessageCircle } from "lucide-react";

export const CTASection = () => {
  return (
    <section
      className="py-20 relative overflow-hidden text-white"
      style={{ background: 'linear-gradient(135deg, #1F1F1F 0%, #2a3040 50%, #1F1F1F 100%)' }}
    >
      {/* Subtle animated glow */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{ background: 'radial-gradient(circle at 50% 50%, #85BCFF 0%, transparent 60%)' }}
        />
      </div>

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-5 leading-tight">
          Agende Sua Consulta <span style={{ color: '#85BCFF' }}>Agora</span>
        </h2>
        <p className="text-lg sm:text-xl mb-10 text-slate-300 max-w-2xl mx-auto">
          Estamos prontos para cuidar do seu sorriso. Atendimento humanizado e personalizado.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={siteData.brand.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 px-10 py-5 rounded-lg text-lg font-bold transition-all duration-200 hover:scale-105 shadow-2xl"
            style={{ backgroundColor: '#85BCFF', color: '#1F1F1F' }}
          >
            <MessageCircle size={22} />
            Falar com a Clínica no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};
